import { LocalizedSmallParagraph } from '@mews-commander/ui';
import { UnicodeEntity } from '@mews/enums';
import { TextKey } from '@mews-commander/enums';
import { Body, Stack } from '@optimus-web/core';
import { DetailedPlatformProfileResult } from '@mews-commander/data-access';
import { parsePlatformProfilePrivilegesToArray, useLocalizePlatformProfilePrivilege } from '../Common/privilegesUtils';
import { PlatformProfileDetailsSection, PlatformProfileDetailsSectionItem } from './PlatformProfileDetailsSection';

export const PlatformProfileData = ({ platformProfile }: { platformProfile: DetailedPlatformProfileResult }) => {
    const localizePrivilege = useLocalizePlatformProfilePrivilege();
    const activePrivileges = parsePlatformProfilePrivilegesToArray(platformProfile.platformProfilePrivileges);

    return (
        <Stack vertical spacing="500">
            <PlatformProfileDetailsSection textKey={TextKey.RolesAndPermissions}>
                <PlatformProfileDetailsSectionItem>
                    <LocalizedSmallParagraph variant="secondary" textKey={TextKey.Role} />
                    <Body size="small">{platformProfile.role}</Body>
                </PlatformProfileDetailsSectionItem>
                <PlatformProfileDetailsSectionItem>
                    <LocalizedSmallParagraph variant="secondary" textKey={TextKey.Privileges} />

                    <Stack vertical spacing="150">
                        {activePrivileges.map((privilege) => {
                            const { label } = localizePrivilege(privilege);
                            return (
                                <Body size="small" key={String(privilege)}>
                                    {label}
                                </Body>
                            );
                        })}

                        {!activePrivileges.length && <Body size="small">{UnicodeEntity.Dash}</Body>}
                    </Stack>
                </PlatformProfileDetailsSectionItem>
            </PlatformProfileDetailsSection>
        </Stack>
    );
};
